import React from 'react';
import { Link } from 'react-router-dom';
import 'bootstrap/dist/css/bootstrap.min.css';

// Writing Items
const writingItems = [
  {
    id: 9,
    image: require("../images/latest-writing/news-9.jpg"),
    name: "PV60",
    date: "29 July 2023",
    description: `
<p>PREMIER is the largest exporter of Liquid Ring Vaccuum Pumps and Spares with installations in more than forty countries.</p>
`
  },




  {
    id: 3,
    image: require("../images/latest-writing/news-3.jpg"),
    name: "PV60",
    date: "16 November 2024",
    description: `
<p>PREMIER make P501 M pump equivalent to NASH 904 M arrives in a paper mill in the U.S.A</p>
<p>Contact PREMIER for your emergency requirements to replace your existing O.E.M Vacuum Pumps and spares.</p>
`
  },

  {
    id: 2,
    image: require("../images/latest-writing/news-7.jpeg"),
    name: "PV60",
    date: "09 January 2025",
    description: `
<p>PREMIER offers its unique performance evaluation services for Liquid Ring Vacuum Pumps with minimum pump shutdown time, giving in time failure predictions and minimizing plant shutdown costs due to pump failure.</p>
`
  },


];
// Writing Items

const News = () => {
  return (
    <div className="container my-5">
      <h1 className="mb-4">News</h1>
      <div className="row">
        {writingItems.map((item) => {
          const plainText = item.description.replace(/<\/?[^>]+(>|$)/g, "");
          const shortText = plainText.length > 80 ? plainText.substring(0, 80) + "..." : plainText;
          return (
            <div key={item.id} className="col-lg-4 col-6  mb-4">
              <div className="card h-100">
                <img src={item.image} className="card-img-top rounded-3" alt={item.name} />
                <div className="card-body">
                  {/* <p className="card-text text-muted">{item.date}</p> */}
                  <p className="card-text">{shortText}</p>
                  <Link
                    to={`/writing-details/${item.id}`}
                    className="stretched-link"
                    state={{
                      name: item.name,
                      date: item.date,
                      description: item.description,
                      image: item.image
                    }}
                  >
                    Read More
                  </Link>
                </div>
              </div>
            </div>
          );
        })}
      </div>
    </div>
  );
};

export default News;
